<!-- 1. GESTION DE MON ANNONCE (Pour le propriétaire ou co-gestionnaire, comme sur Leboncoin) -->
@if (canManage()) {
  <div
    class="rounded-3xl border border-gray-6/80 bg-white/90 dark:bg-gray-1/90 backdrop-blur-xl p-6 shadow-sm flex flex-col gap-4"
  >
    <div class="flex items-center justify-between gap-2 border-b border-gray-5 pb-3">
      <h3 class="text-base font-bold text-gray-12 m-0">Gestion de mon annonce</h3>
      <etxe-property-status-badge [property]="property()" />
    </div>

    @if (missingItemsCount() > 0) {
      <div
        class="p-3 rounded-2xl bg-amber-a2 border border-amber-a5 text-amber-12 text-xs flex items-start gap-2.5"
      >
        <mat-icon class="text-amber-9 text-base w-4 h-4 shrink-0 mt-0.5">warning</mat-icon>
        <div class="flex flex-col gap-0.5">
          <span class="font-bold">
            {{ missingItemsCount() }} information{{ missingItemsCount() > 1 ? 's' : '' }} manquante{{
              missingItemsCount() > 1 ? 's' : ''
            }}
          </span>
          <span class="text-[11px] text-amber-11">Pensez à les compléter pour optimiser votre annonce.</span>
        </div>
      </div>
    }

    <div class="flex flex-col gap-2">
      @if (demoMode()) {
        <button
          mat-button
          type="button"
          (click)="onDemoEditAction('Modifier l’annonce')"
          class="text-gray-12! hover:bg-gray-3! py-2.5! px-3! w-full!"
        >
          <div class="grid grid-cols-[1fr_auto_1fr] items-center w-full">
            <div class="flex items-center justify-start">
              <mat-icon class="text-indigo-9!">edit</mat-icon>
            </div>
            <span class="font-semibold text-center whitespace-nowrap">Modifier l'annonce</span>
            <div class="flex items-center justify-end"></div>
          </div>
        </button>

        <button
          mat-button
          type="button"
          (click)="onDemoEditAction('Paramètres et visibilité')"
          class="justify-start! text-gray-12! hover:bg-gray-3! py-2.5! px-3!"
        >
          <mat-icon class="text-indigo-9! mr-2!">settings</mat-icon>
          <span class="font-semibold">Paramètres et visibilité</span>
        </button>

        <button
          mat-button
          type="button"
          (click)="onDemoEditAction('Co-gestionnaires et invitations')"
          class="justify-start! text-gray-12! hover:bg-gray-3! py-2.5! px-3!"
        >
          <mat-icon class="text-indigo-9! mr-2!">people</mat-icon>
          <span class="font-semibold">Co-gestionnaires et invitations</span>
        </button>

        <button
          mat-button
          type="button"
          (click)="previewAgentClicked.emit()"
          class="justify-start! text-gray-12! hover:bg-gray-3! py-2.5! px-3!"
        >
          <mat-icon class="text-indigo-9! mr-2!">visibility</mat-icon>
          <span class="font-semibold">Voir en tant qu'agent</span>
        </button>
      } @else {
        <a
          mat-button
          [routerLink]="['/properties', property()._id, 'edit']"
          class="text-gray-12! hover:bg-gray-3! py-2.5! px-3! w-full!"
        >
          <div class="grid grid-cols-[1fr_auto_1fr] items-center w-full">
            <div class="flex items-center justify-start">
              <mat-icon class="text-indigo-9!">edit</mat-icon>
            </div>
            <span class="font-semibold text-center whitespace-nowrap">Modifier l'annonce</span>
            <div class="flex items-center justify-end">
              @if (missingItemsCount() > 0) {
                <span
                  class="px-2 py-0.5 rounded-full bg-amber-a4 text-amber-11 text-[10px] font-bold whitespace-nowrap"
                >
                  {{ missingItemsCount() }} à compléter
                </span>
              }
            </div>
          </div>
        </a>

        <a
          mat-button
          [routerLink]="['/properties', property()._id, 'settings']"
          class="justify-start! text-gray-12! hover:bg-gray-3! py-2.5! px-3!"
        >
          <mat-icon class="text-indigo-9! mr-2!">settings</mat-icon>
          <span class="font-semibold">Paramètres et visibilité</span>
        </a>

        @if (canManage()) {
          @let membersCount = (property().members || []).length;
          @if (membersCount === 0) {
            <button
              mat-button
              type="button"
              (click)="openMembersDialog()"
              class="justify-start! text-gray-12! hover:bg-gray-3! py-2.5! px-3!"
            >
              <mat-icon class="text-indigo-9! mr-2!">group_add</mat-icon>
              <span class="font-semibold">Co-gestionnaires et invitations</span>
            </button>
          } @else {
            <a
              mat-button
              [routerLink]="['/properties', property()._id, 'members']"
              class="justify-start! text-gray-12! hover:bg-gray-3! py-2.5! px-3!"
            >
              <mat-icon class="text-indigo-9! mr-2!">people</mat-icon>
              <span class="font-semibold">Co-gestionnaires et invitations</span>
            </a>
          }
        }

        <a
          mat-button
          [routerLink]="['/properties', property()._id, 'preview']"
          class="justify-start! text-gray-12! hover:bg-gray-3! py-2.5! px-3!"
        >
          <mat-icon class="text-indigo-9! mr-2!">visibility</mat-icon>
          <span class="font-semibold">Voir en tant qu'agent</span>
        </a>
      }

      @if (appStore.debugMode()) {
        <button
          mat-button
          type="button"
          (click)="openPdfExportDialog()"
          class="justify-start! text-gray-12! hover:bg-gray-3! py-2.5! px-3!"
        >
          <mat-icon class="text-indigo-9! mr-2!">picture_as_pdf</mat-icon>
          <span class="font-semibold">Exporter la fiche en PDF</span>
        </button>
      }
    </div>

    <!-- Co-gestionnaires Summary -->
    @let members = property().members || [];
    @if (members.length > 0) {
      @if (demoMode()) {
        <button
          type="button"
          (click)="onDemoEditAction('Co-gestionnaires et invitations')"
          class="p-3.5 rounded-2xl bg-indigo-a2 border border-indigo-a4 flex items-center justify-between hover:bg-indigo-a3 transition-colors cursor-pointer text-left w-full"
        >
          <div class="flex items-center gap-2.5">
            <mat-icon class="text-indigo-9">people</mat-icon>
            <div class="text-xs">
              <span class="font-bold text-indigo-12 block">
                {{ members.length }} co-gestionnaire{{ members.length > 1 ? 's' : '' }}
              </span>
              <span class="text-gray-11"> Accès partagé à l'annonce et aux candidatures </span>
            </div>
          </div>
          <mat-icon class="text-indigo-9 text-base">chevron_right</mat-icon>
        </button>
      } @else {
        <a
          [routerLink]="['/properties', property()._id, 'members']"
          class="p-3.5 rounded-2xl bg-indigo-a2 border border-indigo-a4 flex items-center justify-between hover:bg-indigo-a3 transition-colors cursor-pointer text-inherit no-underline"
        >
          <div class="flex items-center gap-2.5">
            <mat-icon class="text-indigo-9">people</mat-icon>
            <div class="text-xs">
              <span class="font-bold text-indigo-12 block">
                {{ members.length }} co-gestionnaire{{ members.length > 1 ? 's' : '' }}
              </span>
              <span class="text-gray-11"> Accès partagé à l'annonce et aux candidatures </span>
            </div>
          </div>
          <mat-icon class="text-indigo-9 text-base">chevron_right</mat-icon>
        </a>
      }
    }

    <!-- Candidatures Summary -->
    @if (property().application; as appInfo) {
      <div class="p-3.5 rounded-2xl bg-indigo-a2 border border-indigo-a4 flex items-center justify-between">
        <div class="flex items-center gap-2.5">
          <mat-icon class="text-indigo-9">groups</mat-icon>
          <div class="text-xs">
            <span class="font-bold text-indigo-12 block">
              {{ (appInfo.appliedCount || 0) + (appInfo.acceptedCount || 0) }} candidature(s)
            </span>
            <span class="text-gray-11">
              {{ appInfo.acceptedCount || 0 }} agent(s) retenu(s) • {{ appInfo.appliedCount || 0 }} en attente
            </span>
          </div>
        </div>
      </div>
    }
  </div>
}
